import React, { useState, useEffect } from 'react';

import AddIcon from '@mui/icons-material/Add';
import {
    Button,
    Container,
    Grid,
    UiDialog as Dialog,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer } from 'common/components';

import * as companiesActions from '../companies/actions';
import * as companiesSelectors from '../companies/selectors';

import * as actions from './actions';
import { ListItems } from './components';
import ProductForm from './components/ProductForm';
import * as selectors from './selectors';

const getCountryOptions = (countries) => {
    return countries.map((item) => ({
        label: item.name,
        value: item.id,
    }));
};

const ParametersWindsContainer = ({
    countries,
    fetchCountries,
    fetchItems,
    handleClickCloseModalProduct,
    handleClickCreate,
    handleClickUpdate,
    isFetching,
    isFetchingCountries,
    isNewRecord,
    isOpenProductForm,
    items,
    pagination,
    prepareDelete,
    reset,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        country: '',
        orderBy: null,
        page: 0,
        pageSize: 25,
        search: '',
        sortBy: null,
        status: 'active',
    });

    useEffect(() => {
        fetchItems(filterData);
        fetchCountries();
        return () => {
            reset();
        };
    }, []);

    const countriesOptions = getCountryOptions(countries);

    return (
        <>
            <Container maxWidth={false}>
                <HeaderContainer>
                    <Grid size="grow" textAlign="right">
                        <Button
                            onClick={() => handleClickCreate()}
                            startIcon={<AddIcon />}
                            sx={{ width: { xs: '100%', md: 'auto' } }}
                            type="button"
                        >
                            {t('Add')}
                        </Button>
                    </Grid>
                </HeaderContainer>

                <ListItems
                    countries={countriesOptions}
                    filterData={filterData}
                    filterItems={fetchItems}
                    handleClickOnDelete={(item) =>
                        prepareDelete(item, filterData)
                    }
                    handleClickUpdate={(item) => handleClickUpdate(item)}
                    isFetching={isFetching}
                    isFetchingCountries={isFetchingCountries}
                    items={items}
                    paginationData={pagination}
                    setFilterData={setFilterData}
                />
            </Container>

            <Dialog
                onClose={() => handleClickCloseModalProduct()}
                open={isOpenProductForm}
                title={`${isNewRecord ? t('Create') : t('Update')}`}
            >
                <ProductForm
                    countries={countriesOptions}
                    filterData={filterData}
                    handleClickCloseForm={() => handleClickCloseModalProduct()}
                />
            </Dialog>
        </>
    );
};

ParametersWindsContainer.propTypes = {
    countries: PropTypes.array,
    fetchCountries: PropTypes.func,
    fetchItems: PropTypes.func,
    handleClickCloseModalProduct: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    isFetching: PropTypes.bool,
    isFetchingCountries: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    isOpenProductForm: PropTypes.bool,
    items: PropTypes.array,
    pagination: PropTypes.object,
    prepareDelete: PropTypes.func,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    countries: companiesSelectors.getContriesData,
    isFetching: selectors.getItemsIsFetching,
    isFetchingCountries: companiesSelectors.getIsFetchingCountries,
    isNewRecord: selectors.getIsNewRecord,
    isOpenProductForm: selectors.getIsOpenProductForm,
    items: selectors.getItemsData,
    pagination: selectors.getItemsPagination,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCountries: () => dispatch(companiesActions.fetchCountries()),
    fetchItems: (filterData) => dispatch(actions.fetchItems(filterData)),
    handleClickCloseModalProduct: () => dispatch(actions.closeModalProduct()),
    handleClickCreate: () => dispatch(actions.prepareCreate()),
    handleClickUpdate: (item) => dispatch(actions.prepareUpdate(item)),
    prepareDelete: (item, filterData) =>
        dispatch(actions.prepareDelete(item, filterData)),
    reset: () => dispatch(actions.reset()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ParametersWindsContainer);
